<script lang="ts">
  import { Actions, Card, InfoAlert, Loader, PageView } from '$shared/components';
  import MultipleRecord from './partials/MultipleRecord.svelte';
  import SingleRecord from './partials/SingleRecord.svelte';
  import type { EntityViewType } from '$shared/components/types';
  import type { AlertDetailedInfo } from '$provider/models/AlertDetailedInfo';
  import UIErrorMessage from '$shared/constants/UIErrorMessage';
  import ReviewLayout from '$shared/templates/ReviewLayout/ReviewLayout.svelte';
  import { ReviewType } from '$provider/constants/ReviewType';

  interface Props {
    name?: string;
    infoAlertLabel?: string;
    nonReviewable?: boolean;
    entityName: string;
    error?: AlertDetailedInfo | null | undefined | string;
    loading?: boolean;
    hasMultipleRecords?: boolean;
    actionLoading?: boolean;
    actionDisabled?: boolean;
    verifiedOn?: string;
    alert?: string;
    options: EntityViewType | EntityViewType[];
    ongotoentity?: () => void;
    oncloseerror?: () => void;
    oncancel?: () => void;
    onaccept?: (detail: any) => void;
    onreject?: () => void;
    onevent?: (payload: any) => void;
  }

  let {
    name = '',
    infoAlertLabel = '',
    nonReviewable = false,
    entityName,
    error = '',
    loading = false,
    hasMultipleRecords = false,
    actionLoading = false,
    actionDisabled = false,
    verifiedOn = '',
    alert = '',
    options,
    ongotoentity,
    oncloseerror,
    oncancel,
    onaccept,
    onreject,
    onevent
  }: Props = $props();

  const onClickInfo = (): void => {
    ongotoentity?.();
  };
</script>

<ReviewLayout
  {entityName}
  {error}
  dataAttributeName={name}
  type={ReviewType.NeedsReview}
  oncloseerror={oncloseerror}
  oncancel={oncancel}
  ongotoentity={ongotoentity}
>
  {#snippet actions()}
    <div class="actions">
      {#if !hasMultipleRecords && !nonReviewable}
        <Actions loading={actionLoading} disabled={loading || actionDisabled} onaccept={onaccept} onreject={onreject} />
      {/if}
    </div>
  {/snippet}
  {#if nonReviewable}
    <div class="alert">
      <InfoAlert
        infoAlertLabel={infoAlertLabel || UIErrorMessage.UnknowError}
        onclick={onClickInfo}
      />
    </div>
  {:else}
    <PageView {name}>
      {#if loading}
        <div class="loader"><Card><Loader count={3} /></Card></div>
      {:else if Array.isArray(options)}
        <MultipleRecord
          loading={actionLoading}
          optionsList={options}
          disabled={actionDisabled}
          {verifiedOn}
          onaccept={onaccept}
          onreject={onreject}
          onevent={onevent}
        />
      {:else}
        <SingleRecord {alert} {options} {verifiedOn} onevent={onevent} />
      {/if}
    </PageView>
  {/if}
</ReviewLayout>
